import style from  "./Avviso.module.css";
import image from "../../data/img/error.png"
export default function Avviso({ idp }) {
    // const homepage = `${window.location.origin}/?IDP=${idp}`
    return (
        <div className={style.wrapperMain}>
          <div className={style.content}>
            <h1 className={style.title}>Browser non supportato</h1>
    
            <p className={style.desc}>
              Siamo spiacenti, per procedere all’acquisto effettua l’accesso a{" "}
              <strong>WeGest</strong> da un altro browser.
            </p>
          </div>
    
          <img alt="browser non supportato" className={style.img} src={image} />
        </div>
      );
}